import React from 'react';
import PropTypes from 'prop-types';
import { getColorForValue } from '../../Utils/ColorUtils';
import CustomTooltip from '../../Utils/CustomTooltip';

// Expertise Card component
const ExpertiseCard = ({ area, rationale, grade, source, showSource = true }) => {
  // Ensure grade is between 0 and 10
  const numericGrade = Math.min(10, Math.max(0, grade));
  
  // Calculate width percentage
  const widthPercentage = (numericGrade / 10) * 100;
  
  // Get color based on grade
  const barColor = getColorForValue(numericGrade);
  
  return (
    <div className="mb-6">
      <div className="flex flex-col sm:flex-row mb-2">
        <h5 className="text-lg font-medium text-gray-800 mr-2 mb-1 sm:mb-0">{area}</h5>
        <div className="flex items-center flex-shrink-0 sm:ml-auto">
          <span className="text-gray-700 font-medium mr-2">{numericGrade}</span>
          {showSource && source && (
            <CustomTooltip content={source} position="left">
              <span className="text-xs text-blue-600 cursor-help hover:text-blue-800 flex items-center whitespace-nowrap">
                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                Source
              </span>
            </CustomTooltip>
          )}
        </div>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-4 mb-2">
        <div 
          className="h-4 rounded-full" 
          style={{ 
            width: `${widthPercentage}%`,
            backgroundColor: barColor
          }}
        ></div>
      </div>
      <p className="text-sm text-gray-600">{rationale}</p>
    </div>
  );
};

const ExpertiseList = ({ expertiseItems, showSources = true }) => {
  if (!expertiseItems || !Array.isArray(expertiseItems) || expertiseItems.length === 0) {
    return <p className="text-gray-600">No expertise data available.</p>;
  }

  return (
    <div>
      {expertiseItems.map((item, index) => (
        <ExpertiseCard
          key={index}
          area={item.expertise || item.area || item.responsibility || ""}
          rationale={item.rationale}
          grade={item.grade}
          source={item.source}
          showSource={showSources}
        />
      ))}
    </div>
  );
};

ExpertiseList.propTypes = {
  expertiseItems: PropTypes.array,
  showSources: PropTypes.bool
};

export default ExpertiseList;
